module.exports = __webpack_public_path__ + "img/like.6ea5c01f.svg";